module.exports = __webpack_public_path__ + "img/horizontal_4_6_3009.fb49f453.png";